module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTP///////////waf0AoAAAADdFJOUwDfIMe4PcYAAABFSURBVCjPY2AYdECMgbUBzpFtYE+Ac9QTOG/AOZw3mMrgHCBzLkLT3AZ12mkqYZiLnYOiDMUAZKNRLKWqFpSgQgnEQQQAYeMiz0cuc1EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1